import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "icon-wrapper"
}
const _hoisted_3 = {
  class: "body",
  id: "modal-body",
  "data-test": "modal-body",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "button-wrapper" }

import { IonModal, IonTitle } from "@ionic/vue";

import { setChatIframeVisibility } from "@/helpers";
import AppButton from "@/components/Common/AppButton/AppButton.vue";
import AppModalSkeleton from "@/components/Skeletons/AppModalSkeleton/AppModalSkeleton.vue";


interface Button {
  label: string;
  icon?: string;
  isLoading?: boolean;
}
interface Props {
  isOpen: boolean;
  title?: string;
  body?: string;
  primaryButton?: Button;
  secondaryButton?: Button;
  icon?: string;
  isLoading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppModal',
  props: {
    isOpen: { type: Boolean },
    title: {},
    body: {},
    primaryButton: {},
    secondaryButton: {},
    icon: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (__props.isLoading)
    ? (_openBlock(), _createBlock(AppModalSkeleton, {
        key: 0,
        "data-test": "app-modal-skeleton"
      }))
    : (_openBlock(), _createBlock(_unref(IonModal), {
        key: 1,
        ref: "modal",
        "is-open": __props.isOpen,
        "backdrop-dismiss": false,
        onDidPresent: _cache[2] || (_cache[2] = ($event: any) => (_unref(setChatIframeVisibility)('none'))),
        onDidDismiss: _cache[3] || (_cache[3] = ($event: any) => (_unref(setChatIframeVisibility)('block'))),
        "aria-labelledby": "modal-title",
        "aria-describedby": "modal-body",
        "aria-label": __props.title,
        role: "dialog",
        "data-test": "app-modal",
        "aria-busy": "false"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (__props.icon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_ion_icon, {
                    icon: __props.icon,
                    "aria-hidden": "true",
                    "data-test": "modal-icon"
                  }, null, 8, ["icon"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_unref(IonTitle), {
              id: "modal-title",
              size: "small",
              "data-test": "modal-title",
              "aria-hidden": "true"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.title), 1)
              ]),
              _: 1
            }),
            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.body), 1),
            _createElementVNode("div", _hoisted_4, [
              (__props.primaryButton?.label)
                ? (_openBlock(), _createBlock(AppButton, {
                    key: 0,
                    ariaLabel: __props.primaryButton?.label,
                    "data-test": "primary-button",
                    label: __props.primaryButton?.label,
                    size: "default",
                    type: "primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onPrimaryButtonClick'))),
                    isLoading: __props.primaryButton?.isLoading
                  }, null, 8, ["ariaLabel", "label", "isLoading"]))
                : _createCommentVNode("", true),
              (__props.secondaryButton?.label)
                ? (_openBlock(), _createBlock(AppButton, {
                    key: 1,
                    ariaLabel: __props.secondaryButton?.label,
                    "data-test": "secondary-button",
                    label: __props.secondaryButton?.label,
                    size: "default",
                    type: "secondary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onSecondaryButtonClick'))),
                    isLoading: __props.secondaryButton?.isLoading
                  }, null, 8, ["ariaLabel", "label", "isLoading"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["is-open", "aria-label"]))
}
}

})